require('./rentsView.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
// @ actions
const taxAndRentsActions = require('actions/taxAndRents');
// @ components
const Rents = require('components/taxAndRents/rents/rents');
const FiscalInformationLinks = require('components/taxAndRents/fiscalInformationLinks/fiscalInformationLinks');
// @ helpers
const { getControlDigitFromCodBban } = require('utilities/ibanHelper');

class RentsView extends React.Component {
    constructor(props) {
        super(props);
        this.onAccountNumberChange = this.onAccountNumberChange.bind(this);
    }

    onAccountNumberChange(accountId) {
        const { immAccounts, getTaxesAndRents, setAccountNumber } = this.props;
        const account = immAccounts.get('byId').get(accountId);
        const iban = account.getIn(['ibanComplex', 'codbban']);
        const controlDigit = getControlDigitFromCodBban(iban)
        const accountNumber = account.get('product') + account.get('contractNumber');
        setAccountNumber(accountNumber, controlDigit, accountId);
        getTaxesAndRents(accountId);
    }

    buildHeader() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-taxAndRents'),
                url: '/myprofile/taxAndRents/'
            },
            {
                text: formatText('breadcrumb-rents'),
                url: `/myprofile/taxAndRents/rents/`
            }
        ];

        return (
            <OKCover size="medium" section="pg">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle('breadcrumb-taxAndRents')}
                />
            </OKCover>
        );
    }

    render() {
        const header = this.buildHeader();

        return (
            <div className="rents-view">
                {header}
                <div className="rents-view__body">
                    <div className="col-xs-8">
                        <Rents
                            immAccounts={this.props.immAccounts}
                            handleAccountChange={this.onAccountNumberChange}
                            taxAndRents={this.props.taxAndRents}
                            postGetDetails={this.props.postGetDetails}
                            maxNumberOfRows={24}
                            showButton={false}
                        />
                    </div>
                    <div className="col-xs-4">
                        <FiscalInformationLinks />
                    </div>
                </div>
            </div>
        );
    }
}

RentsView.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    taxAndRents: PropTypes.object.isRequired,
    setAccountNumber: PropTypes.func.isRequired,
    getTaxesAndRents: PropTypes.func.isRequired,
    postGetDetails: PropTypes.func.isRequired,
};


module.exports.constructor = RentsView;

module.exports.RentsView = connect(state => ({
    immAccounts: state.accounts,
    taxAndRents: state.taxAndRents
}), {
        getTaxesAndRents: taxAndRentsActions.getTaxesAndRents,
        setAccountNumber: taxAndRentsActions.setAccountNumber,
        postGetDetails: taxAndRentsActions.postGetDetails
    })(RentsView);
